import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=49abfb15&scoped=true&"
import script from "./user-card.vue?vue&type=script&lang=js&"
export * from "./user-card.vue?vue&type=script&lang=js&"
import style0 from "./user-card.vue?vue&type=style&index=0&id=49abfb15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49abfb15",
  null
  
)

export default component.exports